import * as React from "react";
import i18n from "../../../i18n";
import { RouteComponentProps } from "react-router";
import { AppContextProps, withAppContext } from "../../../context/AppContext";
import { BALANCE_CLOSE_PERM, BALANCE_CREATE_PERM, BALANCE_FIND_PERM, BASE_PERM ,BALANCE_PENDING_APPROVAL} from "../../../const/Permission";
import { BalanceAdd } from "./Add";
import { BalanceList } from "./List";
import { BalanceClose } from "./Close";
import { Pending } from "./Pending";
import { findLastOfficeStatus } from "../../../services/Report";
import { ReportOfficeStatus } from "../../../interfaces/ReportOfficeStatus";

export interface BalanceDeviceProps extends RouteComponentProps, AppContextProps{ }
export interface BalanceDeviceState {
    step: number;
 }

export class BalanceDeviceMain extends React.Component<BalanceDeviceProps, BalanceDeviceState>{
    reachTheLastPage: boolean = false;
    constructor(props: BalanceDeviceProps) {
        super(props);
        this.hasPendingActions = this.hasPendingActions.bind(this);
        this.state = {
            step: this.props.havePermission(BALANCE_CLOSE_PERM) ? 0 : 2
        };
    }

    componentDidMount() {
        this.hasPendingActions();
    }

    hasPendingActions() : void {
        if(this.props.authUser && this.props.authUser.branchOffice && this.props.authUser.branchOffice.code !== 'CUID' && this.props.authUser.branchOffice.code !== '1')
        {
            this.props.showLoading(true);
            findLastOfficeStatus(this.props.authUser.branchOffice.code).then((statusOffice: ReportOfficeStatus[]) => {
                if(this.props.authUser && this.props.authUser.role.codeRole == "SUCSP"){
                    if (statusOffice.length !== 0 && statusOffice[0].pendingApproval){
                       this.setStep(3);
                    }
                }
            }).finally(()=>{
                this.props.showLoading(false);
            });
        }
    }

    setStep(step: number): any {
        this.setState({ step });
    }

    render() {
        return (
            <div className="panel-tabs">
                <div className="panel-heading">
                    <ul className="nav nav-tabs">
                        {this.props.havePermission(BALANCE_CLOSE_PERM) && <li className={this.state.step === 0 ? "active" : ""}><a onClick={() => this.setStep(0)} href="#" className="nav-link" >{i18n.t('make-balance-close')}</a></li>}
                        {this.props.havePermission(BALANCE_CREATE_PERM) && <li className={this.state.step === 1 ? "active" : ""}><a onClick={() => this.setStep(1)} href="#" className="nav-link" >{i18n.t('make-balance')}</a></li>}
                        {this.props.havePermission(BALANCE_FIND_PERM) && <li className={this.state.step === 2 ? "active" : ""}><a onClick={() => this.setStep(2)} href="#" className="nav-link" >{i18n.t('see-balances')}</a></li>}
                        {this.props.havePermission(BALANCE_PENDING_APPROVAL) && <li className={this.state.step === 3 ? "active" : ""}><a onClick={() => this.setStep(3)} href="#" className="nav-link" >{i18n.t('pending-closures')}</a></li>}
                    </ul>
                </div>
                {this.state.step === 0 && this.props.havePermission(BALANCE_CLOSE_PERM) &&
                <BalanceClose/>
                }
                {this.state.step === 1 && this.props.havePermission(BALANCE_CREATE_PERM) &&
                <BalanceAdd onlyStockSetter={true} />
                }
                {this.state.step === 2 && this.props.havePermission(BALANCE_FIND_PERM) &&
                <BalanceList/>
                }
                {this.state.step === 3 && this.props.havePermission(BALANCE_PENDING_APPROVAL) &&
                <Pending/>
                }
            </div>
        )
    }
}

export const BalanceDevice = withAppContext(BalanceDeviceMain);
